import { FeaturePermission } from "@/__generated__/featurePermissions";
import { useUser } from "@/auth/useUser";
import { MEDICAL_DIRECTOR } from "@/types";

export const useIsGfeReviewer = () => {
  const { userMedspa, newPermissionsEnabledForUser, hasFeaturePermission } =
    useUser();

  return newPermissionsEnabledForUser
    ? hasFeaturePermission(FeaturePermission.IS_GFE_REVIEWER)
    : userMedspa?.role === MEDICAL_DIRECTOR && userMedspa?.isGfeReviewer;
};
